<template>
    <div>
        <AppInput
            :name="errorLabel || name || label"
            :rules="rules"
            :label="label"
            v-slot="{errors, valid}"
            :row="row"
            :helperMessage="helperMessage"
            :model-value="internalValue"
        >
            <v-text-field
                type="date"
                :model-value="internalValue"
                @update:model-value="onDateChange"
                label=""
                variant="outlined"
                density="compact"
                :max="max"
                :min="min"
                :error-messages="errors && errors.length > 0 ? [''] : []"
                :disabled="disabled"
            ></v-text-field>
        </AppInput>
    </div>
</template>

<script>
import AppInput from "@/components/forms/AppInput";
import moment from "moment";

export default {
    components: { AppInput },
    props: {
        modelValue: {
            required: false,
        },
        value: {
            required: false,
        },
        label: {
            required: true,
            type: String
        },
        placeholder: {
            type: String,
        },
        allowedDates: {},
        disabled: {
            type: Boolean
        },
        max: {},
        min: {},
        startWithYear: {
            type: Boolean,
            default: false
        },
        errorLabel: {},
        rules: {},
        row: {
            type: Boolean
        },
        clearable: {
            type: Boolean
        },
        helperMessage: {},
        name: {
            type: String
        },
        dateFormat: {
            type: String
        }
    },
    emits: ['update:modelValue', 'input'],
    name: "AppFormDatePicker",
    computed: {
        currentValue() {
            return this.modelValue !== undefined ? this.modelValue : this.value;
        },
        internalValue() {
            if (!this.currentValue) return '';
            const parsed = moment(this.currentValue);
            if (parsed.isValid()) {
                return parsed.format('YYYY-MM-DD');
            }
            return '';
        }
    },
    methods: {
        onDateChange(value) {
            if (value) {
                const formatted = moment(value).format('YYYY-MM-DD');
                this.$emit('update:modelValue', formatted);
                this.$emit('input', formatted);
            } else {
                this.$emit('update:modelValue', null);
                this.$emit('input', null);
            }
        }
    }
}
</script>

<style scoped>
</style>
